import { useState } from "react";
import { useTranslation } from "react-i18next";
import { formatPhoneNumberIntl } from "react-phone-number-input";

import { FacilityRead } from "@/types/facility/facility";

interface Props {
  facility?: Pick<
    FacilityRead,
    "name" | "address" | "phone_number" | "email" | "read_print_image_url"
  >;
  fallbackName?: string;
  title?: string;
}

export default function FacilityPrintHeader({
  facility,
  fallbackName,
  title,
}: Props) {
  const { t } = useTranslation();
  const [failedImage, setFailedImage] = useState<string>();
  const imageUrl = facility?.read_print_image_url;
  return (
    <div className="flex min-w-0 flex-1 items-start gap-3">
      <div className="min-w-0 flex-1">
        <h1 className="text-2xl font-semibold leading-tight">
          {facility?.name || fallbackName}
        </h1>
        {facility?.address && (
          <p className="mt-0.5 max-w-2xl text-xs leading-snug text-gray-600">
            {facility.address}
          </p>
        )}
        {facility?.phone_number && (
          <p className="mt-0.5 text-xs text-gray-600">
            {t("phone")}:{" "}
            {formatPhoneNumberIntl(facility.phone_number) ||
              facility.phone_number}
          </p>
        )}
        {facility?.email && (
          <p className="mt-0.5 break-words text-xs text-gray-600">
            {t("email")}: {facility.email}
          </p>
        )}
        {title && (
          <h2 className="mt-1 text-sm font-semibold !text-black">{title}</h2>
        )}
      </div>
      {imageUrl && imageUrl !== failedImage && (
        <img
          src={imageUrl}
          alt={t("hospital_print_image")}
          className="h-16 max-h-16 w-24 max-w-24 shrink-0 object-contain"
          onError={() => setFailedImage(imageUrl)}
        />
      )}
    </div>
  );
}
